// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"5dcea9eb","388":"cd5af83f","631":"5382f040","688":"7d14c725","719":"9e57878f","745":"dce39e88"}[chunkId] + ".chunk.css";
};